/* drøm — "Pick a koala, win a prize" full-page first-visit game.
   Captures the email into Klaviyo Email List (TKiSW3) and reveals DROM20. */
(function () {
  'use strict';
  if (window.__dromKoalaGame) return;
  window.__dromKoalaGame = true;

  // Never run inside the theme editor.
  try { if (window.Shopify && window.Shopify.designMode) return; } catch (e) {}

  // Once someone submits an email we stop showing it (we've got them).
  // Opt-outs never set this, so the game returns on their next visit.
  var CLAIMED_KEY = 'dromKoalaClaimed';
  var SESSION_KEY = 'dromKoalaShown';
  try { if (localStorage.getItem(CLAIMED_KEY)) return; } catch (e) {}
  // Don't re-pop on every page within the same visit; it returns next visit.
  try { if (sessionStorage.getItem(SESSION_KEY)) return; } catch (e) {}

  var KOALA = 'https://cdn.shopify.com/s/files/1/0820/0768/7385/files/drom-koala-plum.png?v=1784395762';
  var COMPANY = 'UkybrA';
  var LIST = 'TKiSW3';
  var CODE = 'DROM20';
  var PRIZE = '20% OFF';
  var DELAY = 5000;

  var CSS = [
    '.dromkg{position:fixed;inset:0;z-index:2147483000;font-family:"Nunito","Segoe UI",system-ui,-apple-system,sans-serif;}',
    '.dromkg *{box-sizing:border-box;}',
    '.dromkg__stage{position:absolute;inset:0;overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:48px 22px;',
      'background:radial-gradient(900px 420px at 18% 8%,#fde3f3 0%,rgba(253,227,243,0) 60%),radial-gradient(1000px 480px at 85% 12%,#e9ddfb 0%,rgba(233,221,251,0) 55%),linear-gradient(165deg,#f7eefc 0%,#efe4fb 45%,#f9eef4 100%);}',
    '.dromkg__blob{position:absolute;border-radius:50%;filter:blur(30px);opacity:.55;z-index:0;pointer-events:none;}',
    '.dromkg__blob.b1{width:340px;height:340px;background:#f7c9e8;top:-80px;left:-60px;}',
    '.dromkg__blob.b2{width:300px;height:300px;background:#d9c2f5;bottom:-90px;right:-40px;}',
    '.dromkg__blob.b3{width:220px;height:220px;background:#ffe3b8;bottom:10%;left:6%;opacity:.4;}',
    '.dromkg__confetti{position:absolute;inset:0;pointer-events:none;z-index:6;}',
    '.dromkg__skip{position:absolute;top:20px;right:24px;z-index:8;color:#6b6088;font-size:.82rem;text-decoration:underline;background:none;border:none;cursor:pointer;}',
    '.dromkg__brand{display:inline-flex;align-items:center;gap:9px;margin-bottom:18px;}',
    '.dromkg__brand img{width:34px;height:34px;object-fit:contain;}',
    '.dromkg__brand span{font-size:1.5rem;font-weight:800;color:#46266e;}',
    '.dromkg__kicker{display:inline-flex;align-items:center;gap:7px;background:#fff;color:#a0338c;font-weight:800;font-size:.72rem;letter-spacing:.09em;text-transform:uppercase;padding:7px 15px;border-radius:999px;margin-bottom:16px;box-shadow:0 6px 18px rgba(120,40,120,.1);}',
    '.dromkg h1{font-size:2.7rem;line-height:1.08;color:#46266e;margin:0 0 10px;font-weight:800;letter-spacing:-.01em;}',
    '.dromkg h2{font-size:2.3rem;color:#46266e;margin:8px 0 4px;font-weight:800;}',
    '.dromkg__sub{color:#6b6088;font-size:1.08rem;line-height:1.5;margin:0 auto 30px;max-width:520px;}',
    '.dromkg__content{position:relative;z-index:2;width:100%;max-width:760px;margin:0 auto;}',
    '.dromkg__koalas{display:flex;gap:26px;justify-content:center;margin:8px 0 22px;flex-wrap:wrap;}',
    '.dromkg__koala{width:184px;max-width:40vw;aspect-ratio:1/1;border:none;background:transparent;cursor:pointer;perspective:900px;padding:0;}',
    '.dromkg__inner{position:relative;display:block;width:100%;height:100%;transform-style:preserve-3d;transition:transform .55s cubic-bezier(.2,.8,.3,1);}',
    '.dromkg__koala.flipped .dromkg__inner{transform:rotateY(180deg);}',
    '.dromkg__face,.dromkg__back{position:absolute;inset:0;border-radius:28px;display:flex;align-items:center;justify-content:center;backface-visibility:hidden;-webkit-backface-visibility:hidden;box-shadow:0 16px 34px rgba(90,40,110,.14);}',
    '.dromkg__face{background:linear-gradient(160deg,#fbf3ff,#e9def6);border:2px solid #e0d5ef;transition:transform .16s,box-shadow .16s,border-color .16s;}',
    '.dromkg__face img{width:62%;height:62%;object-fit:contain;}',
    '.dromkg__q{position:absolute;bottom:14px;right:16px;color:#a0338c;font-weight:900;font-size:1.5rem;opacity:.6;}',
    '.dromkg__back{background:linear-gradient(160deg,#a0338c,#7d2a86);color:#fff;transform:rotateY(180deg);flex-direction:column;gap:3px;padding:10px;}',
    '.dromkg__back .amt{font-size:1.8rem;font-weight:900;line-height:1;}',
    '.dromkg__back .lbl{font-size:.68rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.92;}',
    '.dromkg__koala:not(.disabled):hover .dromkg__face{transform:translateY(-7px);box-shadow:0 22px 40px rgba(120,40,120,.22);border-color:#a0338c;}',
    '.dromkg__koala.dim{opacity:.4;filter:saturate(.7);}',
    '.dromkg__stephint{font-size:.95rem;color:#6b6088;margin:0;font-weight:600;}',
    '.dromkg__field{display:flex;gap:10px;max-width:440px;margin:0 auto 10px;}',
    '.dromkg__field input{flex:1 1 auto;min-width:0;border:1.8px solid #e0d5ef;border-radius:999px;padding:16px 22px;font-size:1.05rem;color:#46266e;font-family:inherit;background:#fff;box-shadow:0 8px 22px rgba(90,40,110,.08);}',
    '.dromkg__field input:focus{outline:none;border-color:#a0338c;}',
    '.dromkg__hint{font-size:.88rem;color:#6b6088;margin:2px 0 0;min-height:1.1em;}',
    '.dromkg__hint.err{color:#c0392b;font-weight:700;}',
    '.dromkg__fine{font-size:.72rem;color:#9a8fb0;margin:18px auto 0;max-width:460px;line-height:1.45;}',
    '.dromkg__panel{display:none;position:relative;z-index:2;width:100%;max-width:620px;margin:0 auto;}',
    '.dromkg__panel.show{display:block;animation:dromkgpop .45s cubic-bezier(.2,.9,.3,1.2) both;}',
    '@keyframes dromkgpop{from{transform:translateY(16px) scale(.96);opacity:0;}to{transform:none;opacity:1;}}',
    '.dromkg__prize{font-size:3.6rem;font-weight:900;color:#a0338c;margin:4px 0;line-height:1;}',
    '.dromkg__code{display:inline-flex;align-items:center;gap:12px;background:#fff;border:2px dashed #a0338c;color:#46266e;font-weight:900;letter-spacing:.05em;padding:14px 22px;border-radius:16px;margin:12px 0 4px;font-size:1.25rem;box-shadow:0 10px 26px rgba(120,40,120,.12);}',
    '.dromkg__code button{border:none;background:#a0338c;color:#fff;font-weight:800;font-size:.72rem;padding:7px 12px;border-radius:9px;cursor:pointer;letter-spacing:.05em;}',
    '.dromkg__cta{display:inline-block;min-width:280px;background:#a0338c;color:#fff;font-weight:800;font-size:1.05rem;padding:17px 30px;border-radius:999px;text-decoration:none;border:none;cursor:pointer;margin-top:6px;box-shadow:0 12px 28px rgba(160,51,140,.28);}',
    '.dromkg__cta:hover{background:#8a2c78;}',
    '.dromkg__cta.busy{opacity:.6;cursor:default;}',
    '.dromkg__replay{display:none;}',
    '@media (max-width:560px){.dromkg h1{font-size:2rem;}.dromkg h2{font-size:1.7rem;}.dromkg__sub{font-size:.98rem;}.dromkg__koalas{gap:14px;}.dromkg__koala{width:108px;}.dromkg__field{flex-direction:column;}.dromkg__prize{font-size:2.7rem;}}'
  ].join('');

  function koalaHTML() {
    return '<button class="dromkg__koala"><span class="dromkg__inner">' +
      '<span class="dromkg__face"><img src="' + KOALA + '" alt=""><span class="dromkg__q">?</span></span>' +
      '<span class="dromkg__back"><span class="amt"></span><span class="lbl"></span></span>' +
      '</span></button>';
  }
  function brandHTML() {
    return '<div class="dromkg__brand"><img src="' + KOALA + '" alt=""><span>drøm</span></div>';
  }

  function overlayHTML() {
    return '<div class="dromkg__stage">' +
      '<div class="dromkg__blob b1"></div><div class="dromkg__blob b2"></div><div class="dromkg__blob b3"></div>' +
      '<button class="dromkg__skip" data-act="close">No thanks</button>' +
      '<canvas class="dromkg__confetti"></canvas>' +
      '<div class="dromkg__content" data-step="game">' + brandHTML() +
        '<h1>Pick a koala, win a prize!</h1>' +
        '<p class="dromkg__sub">Every koala’s holding a treat — pick one to reveal your reward.</p>' +
        '<div class="dromkg__koalas">' + koalaHTML() + koalaHTML() + koalaHTML() + '</div>' +
        '<p class="dromkg__stephint">👆 Tap a koala to reveal your prize</p>' +
      '</div>' +
      '<div class="dromkg__panel" data-step="claim">' + brandHTML() +
        '<h2>You’ve won 20% off</h2>' +
        '<p class="dromkg__sub" style="margin-bottom:18px;">Enter your email to unlock your code.</p>' +
        '<div class="dromkg__field"><input type="email" data-el="email" placeholder="Enter your email" autocomplete="email" inputmode="email"></div>' +
        '<button class="dromkg__cta" data-act="claim" style="min-width:0;width:100%;max-width:440px;">Unlock my code</button>' +
        '<p class="dromkg__hint" data-el="hint"></p>' +
        '<p class="dromkg__fine">By entering you agree to receive email marketing from drøm. Unsubscribe anytime. One prize per customer.</p>' +
      '</div>' +
      '<div class="dromkg__panel" data-step="win">' + brandHTML() +
        '<h2>Here’s your 20% off</h2>' +
        '<p class="dromkg__sub" style="margin-bottom:6px;">Use this code at checkout — it’s also on its way to your inbox.</p>' +
        '<div class="dromkg__code"><span data-el="code">' + CODE + '</span><button data-act="copy">COPY</button></div><br>' +
        '<a class="dromkg__cta" data-act="shop" href="/products/drom-sleep-gummies-mixed-berry">Shop drøm →</a>' +
      '</div>' +
    '</div>';
  }

  function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

  function build() {
    if (document.getElementById('dromkg-root')) return;
    if (!document.getElementById('dromkg-style')) {
      var st = document.createElement('style'); st.id = 'dromkg-style'; st.textContent = CSS; document.head.appendChild(st);
    }
    var root = document.createElement('div');
    root.className = 'dromkg'; root.id = 'dromkg-root';
    root.innerHTML = overlayHTML();
    (document.documentElement || document.body).appendChild(root);
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    var steps = {
      game: root.querySelector('[data-step="game"]'),
      claim: root.querySelector('[data-step="claim"]'),
      win: root.querySelector('[data-step="win"]')
    };
    var koalas = Array.prototype.slice.call(root.querySelectorAll('.dromkg__koala'));
    var done = false;

    function close() { document.body.style.overflow = prevOverflow; if (root.parentNode) root.parentNode.removeChild(root); }

    var cv = root.querySelector('.dromkg__confetti'), ctx = cv.getContext('2d'), parts = [], running = false;
    function size() { cv.width = window.innerWidth; cv.height = window.innerHeight; }
    size(); window.addEventListener('resize', size);
    var COL = ['#a0338c', '#46266e', '#f6b6df', '#c58ae0', '#ffd36e'];
    function burst() {
      var cx = window.innerWidth / 2, cy = window.innerHeight * 0.42;
      for (var i = 0; i < 110; i++) parts.push({ x: cx, y: cy, vx: (Math.random() - .5) * 13, vy: (Math.random() * -11) - 2, g: .28 + Math.random() * .2, s: 6 + Math.random() * 8, c: COL[i % COL.length], r: Math.random() * 6, vr: (Math.random() - .5) * .4, life: 70 + Math.random() * 40 });
      if (!running) { running = true; requestAnimationFrame(loop); }
    }
    function loop() {
      ctx.clearRect(0, 0, cv.width, cv.height);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.vy += p.g; p.x += p.vx; p.y += p.vy; p.r += p.vr; p.life--;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * .6); ctx.restore();
        if (p.life <= 0 || p.y > cv.height + 30) parts.splice(i, 1);
      }
      if (parts.length) requestAnimationFrame(loop); else running = false;
    }

    koalas.forEach(function (k) {
      k.addEventListener('click', function () {
        if (done) return; done = true;
        koalas.forEach(function (o) { o.classList.add('disabled'); if (o !== k) o.classList.add('dim'); });
        k.querySelector('.amt').textContent = PRIZE;
        k.querySelector('.lbl').textContent = 'off order';
        k.classList.add('flipped');
        burst();
        setTimeout(function () {
          steps.game.style.display = 'none';
          steps.claim.classList.add('show');
          var e = steps.claim.querySelector('[data-el="email"]'); if (e) e.focus();
        }, 1050);
      });
    });

    function claim() {
      var input = steps.claim.querySelector('[data-el="email"]');
      var hint = steps.claim.querySelector('[data-el="hint"]');
      var btn = steps.claim.querySelector('[data-act="claim"]');
      var email = (input.value || '').trim();
      if (!validEmail(email)) { hint.textContent = 'Please enter a valid email 🐨'; hint.className = 'dromkg__hint err'; return; }
      hint.textContent = ''; btn.classList.add('busy'); btn.disabled = true; btn.textContent = 'Unlocking…';
      var body = { data: { type: 'subscription', attributes: { custom_source: 'Koala Game', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } };
      function reveal() { steps.claim.classList.remove('show'); steps.claim.style.display = 'none'; steps.win.classList.add('show'); burst(); }
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY, {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-04-15' }, body: JSON.stringify(body)
      }).then(function () { try { localStorage.setItem(CLAIMED_KEY, '1'); } catch (e) {} reveal(); }).catch(function () { reveal(); });
    }
    steps.claim.querySelector('[data-act="claim"]').addEventListener('click', claim);
    steps.claim.querySelector('[data-el="email"]').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); claim(); } });

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-act]') : null; if (!t) return;
      var act = t.getAttribute('data-act');
      if (act === 'close') { close(); }
      else if (act === 'copy') { try { navigator.clipboard.writeText(CODE); } catch (x) {} t.textContent = 'COPIED'; }
      else if (act === 'shop') { close(); }
    });
  }

  function schedule() { setTimeout(build, DELAY); }
  if (document.readyState === 'complete' || document.readyState === 'interactive') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
})();
